// extracted by mini-css-extract-plugin
export default {"container":"Reset_container__yJCeE","form":"Reset_form__QfQPN","back":"Reset_back__9w3En"};